"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AuthContext = require("../context/AuthContext");
var useOrgFeatureFlag = function useOrgFeatureFlag(feature) {
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    orgHelper = _useAuthInfo.orgHelper;
  var orgId = orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrgIds()[0];
  var org = orgId ? orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrg(orgId) : undefined;
  var fetchFeature = function fetchFeature(feature) {
    var _org$orgMetadata;
    var flags = org === null || org === void 0 || (_org$orgMetadata = org.orgMetadata) === null || _org$orgMetadata === void 0 ? void 0 : _org$orgMetadata.feature_flags;
    if (flags) {
      return flags[feature] === undefined ? false : flags[feature];
    }
    return false;
  };
  return fetchFeature(feature);
};
var _default = exports.default = useOrgFeatureFlag;